const newUnit = {
  snackbar: "Su actualización esta completada",
  name: "Nombre de Unidad",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Unidad",
  formTitle: "Nueva Unidad",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newUnit;
